export const groupConstant = {
    groups: 'GROUP.GROUPS',
    title: 'GROUP.TITLE',
    createGroup: 'GROUP.CREATE_GROUP',
    details: 'GROUP.DETAILS',
    regex: {
        title: 'GROUP.REGEX.TITLE',
        description: 'GROUP.REGEX.DESCRIPTION',
        example: 'GROUP.REGEX.EXAMPLE',
        modal: {
            title: 'GROUP.REGEX.MODAL.TITLE',
            description: 'GROUP.REGEX.MODAL.DESCRIPTION',
            label: 'GROUP.REGEX.MODAL.LABEL'
        }
    },
    addedMembers: 'GROUP.ADDED_MEMBERS',
    createNewGroup: {
        default: 'GROUP.CREATE_NEW_GROUP.DEFAULT',
        description: 'GROUP.CREATE_NEW_GROUP.DESCRIPTION'
    },
    default: 'GROUP.DEFAULT',
    name: 'GROUP.NAME',
    description: 'GROUP.DESCRIPTION',
    form: {
        description: 'GROUP.FORM.DESCRIPTION'
    },
    members: {
        default: 'GROUP.MEMBERS.DEFAULT',
        description: 'GROUP.MEMBERS.DESCRIPTION'
    },
    createdBy: 'GROUP.CREATED_BY',
    createdOn: 'GROUP.CREATED_ON',
    memberEmail: 'GROUP.MEMBER_EMAIL',
    editGroup: 'GROUP.EDIT_GROUP',
    addMembers: {
        default: 'GROUP.ADD_MEMBERS.DEFAULT',
        description: 'GROUP.ADD_MEMBERS.DESCRIPTION'
    },
    notInAnyGroup: 'GROUP.NOT_IN_ANY_GROUP',
    askAdminToCreateAGroup: 'GROUP.ASK_ADMIN_TO_CREATE_A_GROUP',
    basicInformation: 'GROUP.BASIC_INFORMATION',
    memberAdded: 'GROUP.MEMBERS_ADDED'
};
